export default __webpack_public_path__ + "static/media/universe_bg.f7b57849.jpg";